import { Components, Theme as MuiTheme } from '@mui/material';

export const stepsTheme: Components<MuiTheme> = {
  MuiStepIcon: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-completed': {
          color: theme.palette.background.button,
        },
      }),
    },
  },
  MuiStepConnector: {
    styleOverrides: {
      root: () => ({
        '&.MuiStepConnector-vertical': {
          '& .MuiStepConnector-line': {
            marginLeft: '4px',
          },
        },
      }),
      line: ({ theme }) => ({
        borderColor: theme.palette.primary.main,
      }),
    },
  },
  MuiStepContent: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderColor: theme.palette.primary.main,
        marginLeft: '16px',
      }),
    },
  },
  MuiStepLabel: {
    styleOverrides: {
      root: () => ({
        '&.checkout-step-hidden': {
          visibility: 'hidden',
        },
      }),
    },
  },
};
